export default __webpack_public_path__ + "static/media/tirebuyer-logo-driven.a9f35fac.svg";